<template>
  <div class="fill-height of-y d-flex flex-column">
    
    <template v-if="loading">
      <div class="d-flex fill-height align-center justify-center">
        <loader :size="36"></loader>
      </div>
    </template>
    
    <template v-else>
      <div class="flex-grow-0 pa-2 d-flex justify-space-between">
        <v-btn
            :disabled="loading"
            @click="getUnderPerformerData"
            color="primary"
            small
            :loading="loading"
            class="mx-1"
        >
          Refresh
        </v-btn>
        <v-btn
            class="mx-1"
            :disabled="false"
            @click="exportReportData"
            color="primary"
            small
            :loading="exportingData"
        >
          Export
        </v-btn>
        <div class="flex-grow-1">
        
        </div>
        <div style="width: 30%">
          <v-text-field
              v-model="search"
              prepend-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              class="pa-0 ma-0"
          ></v-text-field>
        </div>
        <!--                <div>-->
        <!--                    <v-btn-->
        <!--                            icon-->
        <!--                            color="primary"-->
        <!--                            class="pa-0 mr-2"-->
        <!--                            @click="$emit('update:selected-date', subDays(selectedDate, 1))"-->
        <!--                    >-->
        <!--                        <v-icon>mdi-chevron-left</v-icon>-->
        <!--                    </v-btn>-->
        <!--                    <v-btn-->
        <!--                            icon-->
        <!--                            color="primary"-->
        <!--                            class="pa-0 mr-2"-->
        <!--                            @click="$emit('update:selected-date', addDays(selectedDate, 1))"-->
        <!--                    >-->
        <!--                        <v-icon>mdi-chevron-right</v-icon>-->
        <!--                    </v-btn>-->
        <!--                </div>-->
      </div>
      
      <div class="flex-grow-1 of-y pa-2">
        
        <v-card class="ma-2">
          <v-data-table
              dense
              hide-default-footer
              :headers="targetHeaders"
              :items="filteredTargets"
              :options="{itemsPerPage: targets.length}"
          >
            <template #item.date="{item}">
              <span class="caption" style="white-space: nowrap">{{format(item.date, 'yyyy-MM-dd')}}</span>
            </template>
            
            <template #item.farmName="{item}">
              <span class="caption">{{item.farmName}}</span>
            </template>
            
            <template #item.team="{item}">
              <span class="caption">Team {{item.team}}</span>
            </template>
            
            <template #item.target="{item}">
              <v-text-field
                  type="number"
                  solo
                  hide-details
                  v-model.number="item.provisionalTarget"
                  style="width: 100px"
                  :background-color="item.provisionalTarget && item.provisionalTarget !== item.target ? 'amber darken-2' : (item.provisionalTarget && item.provisionalTarget === item.target ? undefined : 'error')"
              >
              
              </v-text-field>
            </template>
            
            <template #item.status="{item}">
              
              
              
              <v-tooltip top v-if="item.provisionalTarget && item.provisionalTarget !== item.target">
                <template #activator="{on}">
                  <v-icon
                      v-on="on"
                      color="amber darken-1"
                  >mdi-alert</v-icon>
                </template>
                Save changes to apply
              </v-tooltip>
              
              <v-tooltip top v-else-if="item.provisionalTarget && item.provisionalTarget === item.target">
                <template #activator="{on}">
                  <v-icon
                      v-on="on"
                      color="green darken-1"
                  >mdi-check</v-icon>
                </template>
                Target Captured
              </v-tooltip>
              
              <v-tooltip top v-else>
                <template #activator="{on}">
                  <v-icon
                      v-on="on"
                      color="error"
                  >mdi-alert-circle</v-icon>
                </template>
                Capture Target
              </v-tooltip>
            </template>
            
            <template #item.avgHours="{item}">
              {{+(+(item.avgHours || 0)).toFixed(2)}}
            </template>
            <template #item.avgBins="{item}">
              {{+(+(item.avgBins || 0)).toFixed(2)}}
            </template>
            <template #item.units="{item}">
              {{+(+(item.units || 0)).toFixed(2)}}
            </template>
          
          </v-data-table>
          <v-divider></v-divider>
          <div class="d-flex justify-end pa-2">
            <v-btn @click="resetTargets" small color="grey" text class="mx-1">Reset</v-btn>
            <v-btn :disabled="!targetSaves.length" small color="primary" class="mx-1" @click="saveTargets">Save Changes</v-btn>
          </div>
        </v-card>
        
        <v-card class="ma-2">
          
          <v-data-table
              fixed-header
              height="100%"
              class="fill-height of-y"
              dense
              hide-default-footer
              :headers="employeeHeaders"
              :items="filteredEmployees"
              :options="{itemsPerPage: employees.length}"
          >
            
            <template #item.date="{item}">
              <span class="caption" style="white-space: nowrap">{{format(item.date, 'yyyy-MM-dd')}}</span>
            </template>
            
            <template #item.in="{item}">
              <span class="caption" style="white-space: nowrap">{{format(item.in, 'yyyy-MM-dd')}}</span>
            </template>
            
            <template #item.out="{item}">
              <span class="caption" style="white-space: nowrap">{{format(item.out, 'yyyy-MM-dd')}}</span>
            </template>
            
            <template #item.team="{item}">
              <span class="caption">Team {{item.team}}</span>
            </template>
            
            <template #item.avgHours="{item}">
              {{+(+(item.avgHours || 0)).toFixed(2)}}
            </template>
            
            <template #item.hoursWorked="{item}">
              {{+(+(item.hoursWorked || 0)).toFixed(2)}}
            </template>
            
            <template #item.units="{item}">
              {{+(+(item.units || 0)).toFixed(2)}}
            </template>
            
            <template #item.overTarget="{item}">
              {{(item.overTarget === '-' ? '-' : +(+(item.overTarget || 0)).toFixed(2))}}
            </template>
          
          </v-data-table>
        </v-card>
      
      
      </div>
    </template>
    
  </div>
</template>

<script>

import {addDays, format, subDays} from "date-fns";
import {mapGetters} from "vuex";
import Loader from "../General/Loader/Loader";
import ModifyWarning from "@/components/Setup/Warnings/ModifyWarning.vue";

export default {
  components: {ModifyWarning, Loader},
  props: {
    selectedFarm: Number,
    selectedDate: Date
  },
  data() {
    return {
      search: null,
      
      targetHeaders: [
        {value: "status"},
        {text: "Date", value: "date"},
        {text: "Farm", value: "farmName"},
        {text: "Team", value: "team"},
        {text: "Total Employees", value: "totalEmployees"},
        {text: "Avg Hours", value: "avgHours"},
        {text: "Avg Units", value: "avgBins"},
        {text: "Tot Units", value: "units"},
        {text: "Target Units", value: "target"},
      ],
      employeeHeaders: [
        
        {text: "Farm", value: "farmDescription"},
        {text: "Team", value: "team"},
        {text: "Employee", value: "employeeDescription"},
        {text: "Emp Code", value: "empCode"},
        {text: "In", value: "in"},
        {text: "Out", value: "out"},
        {text: "Hours Worked", value: "hoursWorked"},
        {text: "Units", value: "units"},
        {text: "Over Target", value: "overTarget"},
      ],
      
      
      t: {
        "farmDescription": "Mahela Letsitele",
        "varietyDescription": "STAR RUBY",
        "employeeDescription": "IGLET MOKGADI MOAGI",
        "empCode": "4034",
        "fkFarm": 79,
        "fkVariety": 508,
        "empID": "48925",
        "lastBin": "2024-05-01T13:43:17.000Z",
        "totalBins": 1.3333,
        "clockIn": "2024-05-01T07:16:49.000Z",
        "hoursWorked": 6.4411,
        "employeeProductionUnitsPerDay": 1.86298924,
        "productionVsAvg": 97.075772734943,
        "productionVsTarget": "N/A"
      },
      addDays: addDays,
      subDays: subDays,
      exportingData: false,
      loading: false,
      targets: [],
      employees: [],
      captureItem: null,
      captureValue: null,
    }
  },
  mounted() {
    if (this.selectedFarm && this.selectedDate)
      this.getUnderPerformerData()
  },
  watch: {
    selectedFarm(val) {
      if (val) {
        this.getUnderPerformerData()
      }
    },
    selectedDate: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getUnderPerformerData()
        }
      }
    }
  },
  methods: {
    format,
    
    resetTargets() {
      for (const target of this.targets)
        target.provisionalTarget = target.target || 0
    },
    
    async getUnderPerformerData() {
      
      if (!this.selectedFarm) {
        return alert('Please select a farm')
      }
      
      this.targets = [];
      this.employees = [];
      
      try {
        this.loading = true;
        const data = await this.$newReq('POST', `reports/underPerformersHT`, {start: this.selectedDate, farm: this.selectedFarm})
        
        this.targets = data.targets.map(v => ({
          ...v,
          date: new Date(v.date),
          target: v.target || 0,
          provisionalTarget: v.target || 0
        }))
        
        this.employees = (data.employees || []).map(v => ({
          ...v,
          date: new Date(v.date),
          in: new Date(v.in),
          out: new Date(v.out),
        }))
      } catch (e) {
        console.log(e)
        this.$snack.netWorkError();
      } finally {
        this.loading = false
      }
    },
    exportReportData() {
      this.exportingData = true;
      this.$newReqDownloadFile(
          'POST',
          `reports/underPerformersHT/export`,
          {
            start: this.selectedDate,
            selectedFarm: this.selectedFarm
          },
          `Under Performers Export ${format(new Date(this.selectedDate), 'yyyy-MM-dd')}.xlsx`
      )
          .then(data => {
            console.log(data)
          })
          .catch(e => {
            console.log(e)
            this.$snack.netWorkError();
          })
          .finally(() => {
            this.exportingData = false
          })
    },
    async saveTargets() {
      try {
        this.loading = true;
        await this.$newReq('POST', `reports/underPerformers/captureTargetsHT`, {targets: this.targetSaves, farm: this.selectedFarm})
        await this.getUnderPerformerData()
      } catch (e) {
        console.log(e)
        this.$snack.netWorkError()
      } finally {
        this.loading = false;
      }
    }
  },
  computed: {
    ...mapGetters(['farmsRef']),
    farm() {
      return this.selectedFarm ? this.farmsRef[this.selectedFarm] : null
    },
    
    targetSaves() {
      return this.targets.filter(v => v.provisionalTarget && v.provisionalTarget !== v.target)
    },
    
    filteredTargets() {
      return [...this.targets].filter(v => !!v.team)
          .sort((a,b) => +a.team > +b.team ? 1 : -1)
    },
    
    filteredEmployees() {
      return [...this.employees]
          .sort((a,b) => {
            return +a.team > +b.team ? 1 : -1
          })
    }
    
    // rows() {
    //     return this.data.map(row => {
    //         return {
    //             farmID: row.farm.id,
    //             farm: row.farm.description,
    //             employee: row.emp.fullName,
    //             empCode: row.emp.empCode,
    //             clockIn: row.clockInStr,
    //             lastAction: row.lastActionStr,
    //             binUnits: row.binUnits,
    //             piecework: row.pieceWorkStr,
    //             pWUnits: row.pieceWorkUnits,
    //             hours: row.hours,
    //         }
    //     }).filter((row) => this.selectedFarm ? row.farmID === this.selectedFarm : true)
    // }
  },
}
</script>

<style scoped>

</style>